import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue } from '../../../../Fct/generics';
import { SWAP_ROUTER_ADDRESSES } from '../helpers/constants';
// Path is bytes that represent the path of tokens to trade and the fee tier
// address (20 bytes, 40 characters) -> fee (3 bytes, 6 characters) -> address (20 bytes, 40 characters) etc...
// Example:
// c02aaa39b223fe8d0a0e5c4f27ead9083c756cc2 / 0001f4
// dac17f958d2ee523a2206206994597c13d831ec7 / 0001f4
// a0b86991c6218b36c1d19d4a2e9eb0ce3606eb48
// 7b4328c127b85369d9f82ca0503b000d09cf9180 / 002710 /
// c02aaa39b223fe8d0a0e5c4f27ead9083c756cc2 / 0001f4 /
// dac17f958d2ee523a2206206994597c13d831ec7
export var ExactInput = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'exactInput',
    supportedContracts: SWAP_ROUTER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    params_tuple: {
                        path: new FctBytes({}),
                        recipient: new FctAddress({}),
                        deadline: new FctValue({}),
                        amountIn: new FctValue({ destination: 'wei_amount' }),
                        amountOutMinimum: new FctValue({ destination: 'wei_amount' }),
                    },
                },
            },
            output: {
                amountOut: new FctValue({}),
            },
        });
    },
    initParams: {
        methodParams: {
            params_tuple: {
                deadline: { type: 'global', id: 'blockTimestamp' },
            },
        },
    },
    requiredApprovals: function (params) {
        var path = params.methodParams['params_tuple'].path;
        if (!path.value || typeof path.value !== 'string')
            return [];
        var tokenToApprove = path.value.slice(0, 42);
        return [
            {
                to: tokenToApprove,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
